module.exports = __webpack_public_path__ + "static/media/call.95373ad9.svg";